import { IDBPDatabase } from "idb";
import { logger } from "@amzn/afxtaco-utilities";
import { TACO_IDB_DB, TACO_TABLE_NAMES } from "./DatabaseSchema";
import { getTacoIDB } from "./TacoIDB";

/**
 * Attempts to write a record to TACO's IndexedDB SIMPLE_KVP object store. If
 * the write fails, then it falls back to writing it to localStorage
 */
export const saveToClientStorage = async (
  key: string,
  value: string,
): Promise<void> => {
  try {
    await putToIdb(key, value);
  } catch (error) {
    logger.error({
      loggerMsg: "Unable to write to IndexedDB, falling back to localstorage",
      indexedDbError: error,
    });
    localStorage.setItem(key, value);
  }
};

/**
 * Attempts to read a record from TACO's IndexedDB SIMPLE_KVP object store. If the read
 * fails then it falls back to reading from localStorage
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFromClientStorage = async (key: string): Promise<any> => {
  try {
    return await getFromIdb(key);
  } catch (error) {
    logger.error({
      loggerMsg:
        "Unable to get data from IndexedDB, falling back to localstorage",
      indexedDbError: error,
    });
    return localStorage.getItem(key);
  }
};

/**
 * Attempts to delete a record from TACO's IndexedDB SIMPLE_KVP object store. If the delete
 * fails then it falls back to deleting from localStorage
 */
export const deleteFromClientSTorage = async (key: string): Promise<void> => {
  try {
    return await deleteFromIdb(key);
  } catch (error) {
    logger.error({
      loggerMsg:
        "Unable to delete data from IndexedDB, falling back to localstorage",
      indexedDbError: error,
    });
    localStorage.removeItem(key);
  }
};

const putToIdb = async (key: string, value: string): Promise<void> => {
  const db = getIdb();
  await db.put(TACO_TABLE_NAMES.SIMPLE_KVP, value, key);
};

/**
 * Get a value from TACO's IndexedDB SIMPLE_KVP object store
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getFromIdb = async (key: string): Promise<any> => {
  const db = getIdb();
  return await db.get(TACO_TABLE_NAMES.SIMPLE_KVP, key);
};

const deleteFromIdb = async (key: string): Promise<void> => {
  const db = getIdb();
  return await db.delete(TACO_TABLE_NAMES.SIMPLE_KVP, key);
};

const getIdb = (): IDBPDatabase<TACO_IDB_DB> => {
  const db = getTacoIDB();
  if (!db) {
    throw new Error("Unable to get TACO IDB");
  }
  return db;
};
